// Hindi content for app
const es = {
  search: 'Buscar productos',
  mensClothing: 'Ropa de Hombre',
  womenClothing: 'Ropa de Mujer',
  jewellery: 'Joyería',
  electronics: 'Electrónica',
  fifty_percent_off: 'obtenga hasta un cincuenta por ciento de descuento',
  holiday_season: 'Para la temporada navideña',
  thirty_percent_discount_shirts: 'Obtenga hasta un treinta por ciento de descuento en camisetas',
  login: 'Iniciar sesión',
  register: 'Registrarse',
  help_center: 'centro de ayuda',
  referral_message: 'Invita a un amigo y consigue un descuento del 5%.',
  add_cart: 'Añadir al carrito',
  select_color: 'Seleccionar el color',
  select_size: 'Selecciona el tamaño',
  quantity: 'Cantidad',
  free_shipping: 'Envío gratis y devoluciones gratis',
  login_with_google: 'Iniciar sesión con Google ',
  login_with_fb: 'Iniciar sesión con Facebook ',
  login_with_your_account: 'Ingrese a su cuenta ',
  access_recommendations: 'Obtenga acceso a sus pedidos, lista de deseos y recomendaciones',
  email_or_username: 'Nombre de usuario / número de móvil. / Dirección de correo electrónico ',
  password: 'contraseña',
  password_prompt: 'Ingresa tu contraseña ',
  username_prompt:
    'Ingresa tu Nombre de usuario / número de móvil. / Dirección de correo electrónico ',
  remember_me: 'Recuérdame',
  forgot_password: 'Se te olvidó tu contraseña?',
  create_account: 'crea una cuenta',
  alternate_login: 'O inicie sesión con su cuenta',
  enter_keyword_to_search: 'Ingrese la palabra clave para buscar',
  no_result_found: 'No se han encontrado resultados',
  search_result_for: 'Resultado de búsqueda para ',
  page_not_found: 'Página no encontrada',
  settings: 'Ajustes',
  personal_details: 'Detalles personales',
  your_saved_cards: 'Tus tarjetas guardadas',
  full_name: 'nombre completo',
  phone_number: 'Número de teléfono',
  address: 'Dirección',
  city: 'ciudad',
  pin_code: 'Código PIN',
  state: 'Expresar',
  country: 'País',
  billing_details: 'Detalles de facturación',
  payment_method: 'Método de pago',
  card: 'Tarjeta',
  cash_on_delivery: 'Contra reembolso',
  order_summary: 'Resumen de la orden',
  subTotal: 'Total parcial',
  discount: 'Descuento',
  tax: 'Impuesto @ 12.5%',
  delivery_fee: 'Gastos de envío',
  total: 'Total',
  place_order: 'Realizar pedido',
  remove_from_cart: 'Quitar del carrito',
};

export default es;
